import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router';

import { ProfileMenu } from '~domains/account';

import { MEDIA_QUERY_MIN_WIDTH } from '~shared/lib/responsive';
import { ScreenHeader } from '~shared/ui/screen';

import { Header } from './header';

import { BottomNavigation } from '../navigation';

export const BusinessPagesLayout = () => {
  const isUpLd = useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.lg });

  return (
    <div className="flex min-h-full flex-col bg-white">
      {isUpLd ? <Header /> : <ScreenHeader rightSlot={<ProfileMenu />} />}
      <Outlet />
      {!isUpLd && <BottomNavigation />}
    </div>
  );
};
